import { handleActions } from "redux-actions";
import {
    setSelectedBrands,
    getBrands,
    getBrandsSuccess,
    getBrandsError,
    getBrandByCode,
    getBrandByCodeSuccess,
    getBrandByCodeError,
    updateBrand,
    updateBrandError,
    updateBrandSuccess,
    clearBrands,
    createBrand,
    createBrandSuccess,
    createBrandError,
} from "modules/Brands/services/Brands/actions";

const initialState = {
    isLoading: false,
    codes: [],
    brands: [],
    brand: {},
    selectedBrands: [],
    count: 0
};

export const brandsEntriesReducer = handleActions(
    {
        [clearBrands]: () => ({ ...initialState }),
        [getBrands]: (state) => ({
            ...state,
            codes: [],
            brands: [],
            selectedBrands: [],
            isLoading: true
        }),
        [getBrandsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getBrandsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [getBrandByCode]: (state) => ({
            ...state,
            isLoading: true
        }),
        [getBrandByCodeSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            brand: payload
        }),
        [getBrandByCodeError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [createBrand]: (state) => ({
            ...state,
            isLoading: true
        }),
        [createBrandSuccess]: (state) => ({
            ...state,
            isLoading: false
        }),
        [createBrandError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [updateBrand]: (state) => ({
            ...state,
            isLoading: true
        }),
        [updateBrandSuccess]: (state) => ({
            ...state,
            isLoading: false
        }),
        [updateBrandError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setSelectedBrands]: (state, { payload }) => ({
            ...state,
            selectedBrands: payload
        })
    },
    initialState
);
